import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { Button, Modal } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import useResendVerificationMail from 'hooks/useResendVerificationMail';

import './NeedEmailVerificationModal.styles.scss';

type NeedEmailVerificationModalProps = {
  className?: string;
  listingId?: string;
};

const NeedEmailVerificationModal: React.ForwardRefRenderFunction<
  ModalRef,
  NeedEmailVerificationModalProps
> = (props, ref) => {
  const { className, listingId } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('need-email-verification-modal', className);

  const { t } = useTranslation();

  const { isLoading, resendVerificationMail } = useResendVerificationMail();

  return (
    <Modal ref={modalRef} className={classes} title={t('emailNotVerified')}>
      <p>{t('emailNotVerifiedModalInfo')}</p>
      <p>{t('emailNotVerifiedModalInfo2')}</p>

      <div className="actions">
        <Button variant="link" onClick={modal?.close}>
          {t('cancel')}
        </Button>
        <Button
          disabled={isLoading}
          onClick={() =>
            resendVerificationMail({ listingId }, () => modal?.close())
          }
        >
          {t('resend')}
        </Button>
      </div>
    </Modal>
  );
};

export default forwardRef(NeedEmailVerificationModal);
